import { register, getPrefix } from '../../../Utils'

const IssuuFrame = el => {
  const setFrameHeight = () => {
    const frameWidth = el.offsetWidth
    el.style.height = `${frameWidth * (3 / 5)}px`
  }

  window.addEventListener('resize', setFrameHeight)
  setFrameHeight()
}

register('IssuuFrame', IssuuFrame)
